import { render, staticRenderFns } from "./RelationField.vue?vue&type=template&id=4c91bcba"
import script from "./RelationField.vue?vue&type=script&lang=js"
export * from "./RelationField.vue?vue&type=script&lang=js"
import style0 from "./RelationField.vue?vue&type=style&index=0&id=4c91bcba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports